import {FC} from 'react';
import {Modal, Button} from 'antd';
import s from './style.m.less';

export interface TextTipsProps {
    // eslint-disable-next-line no-unused-vars
    tipsVisible?: boolean;
    // eslint-disable-next-line no-unused-vars
    onCancel?: (args: any) => void;
    buttonTxt?: String;
    msg?: any;
    tipFooter?: any;
}

type FuncType = {
    destroy: () => void;
    // eslint-disable-next-line no-unused-vars
    update: (configUpdate: any) => void;
}

const TextTips: FC<TextTipsProps> = (props) => {
    return (
        <Modal
            open={props.tipsVisible}
            onCancel={props.onCancel}
            destroyOnClose={true}
            closable={false}
            title={null}
            footer={null}
            width={560}
            centered={true}
            maskClosable={false}
        >
            <div className={s.warning_content}></div>
            <div className={s.warning_content_title}> 温馨提示</div>
            <div dangerouslySetInnerHTML={{__html: props.msg}} className={s['warning_content_info']}/>
            <div style={{textAlign: 'center', marginTop: '24px'}}>
                <Button style={{width: '200px'}} type="primary" onClick={props.onCancel}>
                    {props.buttonTxt}
                </Button>
            </div>
        </Modal>
    );
};

export const TextTipsModalInfo = (props: TextTipsProps): FuncType => {
    return Modal.info({
        keyboard: false,
        maskClosable: false,
        icon: null,
        width: 560,
        destroyOnClose: true,
        closable: false,
        centered: true,
        content: (
            <>
                <div className={s.warning_content}/>
                <div className={s.warning_content_title}> 温馨提示</div>
                <div dangerouslySetInnerHTML={{__html: props.msg}} className={s['warning_content_info']}/>
                {/* <div style={{ textAlign: 'center', marginTop: '24px' }}>
                    <Button style={{ width: '200px' }} type="primary" onClick={props.onCancel}>
                        {props.buttonTxt}
                    </Button>
                </div> */}
            </>
        ),
        className: 'text-tips-modal-info',
        zIndex: 10000,
        ...props
    });
};

export const ModalInfo = (props: TextTipsProps): FuncType => {
    return Modal.info({
        keyboard: false,
        maskClosable: false,
        icon: null,
        width: 560,
        destroyOnClose: true,
        closable: false,
        centered: true,
        okText: '  ',
        footer: null,
        content: (
            <>
                <div className={s.warning_content}/>
                <div className={s.warning_content_title}> 温馨提示</div>
                <div className={s['warning_content_info']}>{props.msg}</div>
                <div style={{textAlign: 'center', marginTop: '24px'}}>{props.tipFooter}</div>
            </>
        ),
        className: 'tips-modal-info',
        ...props
    });
};
export default TextTips;
